import styled from 'styled-components';
import { motion } from 'framer-motion';

const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  max-width: 1280px;
  width: 100%;
`;

const MainContainer = styled.div`
  width: 70%;
  padding: 20px;
  padding-top: 0;
  z-index: 4;
  position: relative;
  height: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const MainContent = styled(motion.div)`
  width: 100%;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const duration = 0.3;

const AnimationVariants = {
  initial: {
    opacity: 0,
    y: 15,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration,
      delay: duration,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -15,
    transition: {
      duration,
    },
  },
};

export {
  BodyWrapper,
  BodyContainer,
  MainContainer,
  MainContent,
  AnimationVariants,
};
